import { RouteName } from '@mews-commander/enums';
import { OrderItem } from '@mews-commander/data-access';
import { lt, showSuccessAlert } from '@mews/framework';
import { useResolveRoute } from '@mews/routing';
import { isAccountIdCompany } from '@mews-commander/legacy-entities/src/selectors/bills';
import { useCommanderSelector, useCommanderThunkDispatch } from '@mews-commander/utils';
import { openModal } from '../../app/actions/common';
import { CompanyDetailTabs } from '../../companyDetail/enums';

interface ChangeItemSuccessPopupProps {
    title: Mews.TextKey;
    orderItem: OrderItem;
}

export const useChangeItemSuccessPopup = ({ title, orderItem }: ChangeItemSuccessPopupProps) => {
    const resolveRoute = useResolveRoute();
    const dispatch = useCommanderThunkDispatch();
    const isOrderItemOwnerCompany = useCommanderSelector((state) =>
        isAccountIdCompany(state, { accountId: orderItem?.ownerId })
    );

    const isFutureOrderItem = new Date(orderItem?.consumedUtc) > new Date();
    const description = lt(
        isFutureOrderItem ? 'ItemUpdatedInFutureSuccessSubtitle' : 'ItemUpdatedInPastSuccessSubtitle'
    );

    let actionUrl: string;
    if (!orderItem) return () => {};

    if (isFutureOrderItem) {
        actionUrl = resolveRoute(RouteName.BillActionLog, { id: orderItem.billId });
    } else if (isOrderItemOwnerCompany) {
        actionUrl = resolveRoute(RouteName.CompanyDetail, {
            id: orderItem.ownerId,
            query: { tab: CompanyDetailTabs.Dashboard },
        });
    } else {
        actionUrl = resolveRoute(RouteName.CustomerDashboard, { id: orderItem.ownerId });
    }

    const showChangeItemSuccessPopup = () => {
        showSuccessAlert({
            title: lt(title),
            description,
            action: {
                text: lt('SeeChanges'),
                onClick: () => dispatch(openModal(actionUrl)),
            },
        });
    };

    return showChangeItemSuccessPopup;
};
